import { GetServerSideProps } from 'next'
import { QuizPage } from '@mc/persona-client'
import { getPersonaCheckoutServerProps } from 'pages/utils/getPersonaCheckoutServerProps'

const CheckoutQuizPage = () => <QuizPage />

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const personaProps = await getPersonaCheckoutServerProps(ctx)
  if ('redirect' in personaProps) {
    return personaProps
  }

  return {
    props: {},
  }
}

CheckoutQuizPage.pageSettings = {
  title: 'MasterClass On Call',
  pageName: 'Persona Quiz - Part 1: What do you want to focus on? (pre-login)',
}

export default CheckoutQuizPage
